import { Toast } from 'vant'
import i18n from '@/lang/index.js'
import useUserStore from '@/store/modules/user'
/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			// time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm),'');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].value == ('' + value)) {
			actions.push(datas[key].label);
			return true;
		}
	})
	return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
	var actions = [];
	var currentSeparator = undefined === separator ? "," : separator;
	var temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
		Object.keys(datas).some((key) => {
			if (datas[key].dictValue == ('' + temp[val])) {
				actions.push(datas[key].dictLabel + currentSeparator);
			}
		})
	})
	return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

export function formatBr(str){
	if(str != null){
	  str = str.replace(/\n/g,'<br/>');
	}
	return str;
}
export function formatNumstr(value){
	const newValue = ['', '', '']
	let fr = 1000
	let num = 3
	let text1 = ''
	let fm = 1
	while (value / fr >= 1) {
		fr *= 10
		num += 1
		
	}
	if (num <= 4) { // 千
		if(value % 1000 === 0){
			newValue[0] = parseInt(value / 1000) + ''
		}else{
			newValue[0] = parseFloat(value / 1000).toFixed(1) + ''
		}
		newValue[1] = i18n.global.t('common.thousand')//'千'
	} else if (num <= 8) { // 万
		text1 = parseInt(num - 4) / 3 > 1 ? i18n.global.t('common.tenMillion') : i18n.global.t('common.tenThousand')
		
		fm = text1 === i18n.global.t('common.tenThousand') ? 10000 : 10000000
		if (value % fm === 0) {
			newValue[0] = parseInt(value / fm) + ''
		} else {
			newValue[0] = parseFloat(value / fm).toFixed(2) + ''
		}
		newValue[1] = text1
	} else if (num <= 16) { // 亿
		text1 = (num - 8) / 3 > 1 ? i18n.global.t('common.hundredBillion') : i18n.global.t('common.billion')
		text1 = (num - 8) / 4 > 1 ? i18n.global.t('common.trillions') : text1
		text1 = (num - 8) / 7 > 1 ? i18n.global.t('common.quadrillions') : text1
	
		fm = 1
		if (text1 === i18n.global.t('common.billion')) {
			fm = 100000000
		} else if (text1 === i18n.global.t('common.hundredBillion')) {
			fm = 100000000000
		} else if (text1 === i18n.global.t('common.trillions')) {
			fm = 1000000000000
		} else if (text1 === i18n.global.t('common.quadrillions')) {
			fm = 1000000000000000
		}
		if (value % fm === 0) {
			newValue[0] = parseInt(value / fm) + ''
		} else {
			newValue[0] = parseFloat(value / fm).toFixed(2) + ''
		}
		newValue[1] = text1
	}
	if (value < 1000) {
		newValue[0] = value + ''
		newValue[1] = ''
	}
	return newValue.join('')
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch(e) {
            source[p] = target[p];
        }
    }
    return source;
}
export function isJsonString (str) {
	try{
		if(typeof JSON.parse(str) == 'object'){
			return true
		}
	} catch(e) {
		console.log(e)
	}
	return false
}
export function getUrlParam(url,name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = url.split('?')[1].match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}
export function isSafari(){
	var ua = navigator.userAgent.toLowerCase();
	if(ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
	ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
	ua.indexOf('ios') === -1 && ua.indexOf('brower') === -1){
		return true;
	}else{
		return false;
	}
}
export function iosPostMsg (obj) {
	let backReturn = window.webkit.messageHandlers.eventComplete.postMessage(JSON.stringify(obj));
	return backReturn;
}
export function androidPostMsg (obj) {
	let backReturn = sdkpayapi.callAndroidFunction(JSON.stringify(obj));
	return backReturn;
}
export function commonPostMsg (params){
	let isweb = useUserStore().isweb
	if(isweb == 1){
		// if(process.env.NODE_ENV === 'development'){
		// 	let testSign = "fxHxLgwMIItmZ/ACi6Iq0wQJ3ZzG5pPE+gZ99GjegIXOE/G3rOb2yD2pAcZYDiKpV4Uz1H+w/i7s2jnZlzNEN4loifdweNrbtsyK6d9HBXDEL7pK6Io741/Sr7ffw1e7SCptHcE2CWtdBWaomWyjWepEWjG4G8p38CDG4Jr0JNKI65otc1fVcIReKQaYDICeJwExkyosC+OXbEIvytAHMGMtlIcC+C/5pmdkQU4SQumSGKjw0Q6xO2MvytefoH+0CqTBIZ19BOUfymVkWnKF0zWMC1uW7WpRHiW0/OCb0nKeusrYpyfkrNwx01jhkF9t89ltsfuv0cZGMOkZ9HgLjRXwuDeRX51gDcNuvL0QdZxkdL4YVTTaRgNu2+eUhxVz4C7inV/xdVFQ2u2Iqk26McUVBuJdubyrEYR2qVF4UZCsKGy4SETNqVnG5NFe0suuK0vUQ1S7J4Gm9v6dn8JgwJsDb8vGHHqhmG9cROx6s5mz3nHxEivoyR5wptPv8Aqz";
		// 	useUserStore().setSign(testSign).then(() => {
		// 		console.log('存web端信息')
		// 		useUserStore().setRoleInfo({
		// 			gameId: 838,
		// 			// platformId: 2004,
		// 			// serviceId: '10030', 
		// 			// serviceName: '혜택30', 
		// 			// userId: '9754998', 
		// 			// userName: 'null', 
		// 			// roleIdPublish: '15503940', 
		// 			// roleId: '43078521978910', 
		// 			// roleName: '이샹링'
		// 		})
		// 	});
		// 	// if(params.action == 'webPayMsgInfo'){
		// 	// 	useUserStore().setOrderInfo({
		// 	// 		orderId: 17356183,
		// 	// 		totalMoney: 1200,
		// 	// 		SuperUserId: '9754998',
		// 	// 		goodName: '240원보',
		// 	// 		goodid: "2501",
		// 	// 		num: 1
		// 	// 	})
		// 	// }
		// }else{
			params.key = '7paH5SuperGMsdk'
			// if(params.action == 'webDidLoad'){
				console.log('向父级发送消息====')
			// }else{
				params.func = params.action
				window.parent.postMessage(JSON.stringify(params), 'https://pay.gm321321.com')
			// }
		// }
		
		console.log('web端==：'+JSON.stringify(params))
	}else{
		var u = navigator.userAgent;
		var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		if(isIos){
			console.log('调用苹果端:'+JSON.stringify(params))
			iosPostMsg(params)
		}else if(isAndroid){
			console.log('调用安卓端:'+JSON.stringify(params))
			androidPostMsg(params)
		}
	}
}
export function sdkPay (status, msg){
	let args = { action: status, data: msg }
	commonPostMsg(args)
}
